
import Vue from "vue";
import { APPLICATION } from "@/store/applications";
import { UI } from "@/store/ui";
import { mapGetters } from "vuex";
import { ROUTE_NAMES } from "@/routes";
import { IRootState } from "@/store/types";
import { REFERENCE_DATA } from "@/store/referenceData";
import { STANDARD_OFFER } from "@/store/standardOffer";
import { IApplicationDto } from "@/store/applications/types";
import store from "@/store";
import { PROMO_CODES } from "@/store/promoCodes";
import { ITimelineItem } from "@/store/task/types";
import { CREDIT, TELNET, SUPPORT } from "@/constants/roles";
import { isInSomeRole } from "@/helpers/auth";

export default Vue.extend({
  async created() {

    await this.fetchData();
  },
  data() {
    return {
      active: null,
    };
  },
  watch: {
    $route: "fetchData",
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch(
        APPLICATION.NS(APPLICATION.ACTIONS.RESET_APPLICATION_DATA_STATE)
      );
      // need to await here to prevent race condition
      await this.$store.dispatch(
        REFERENCE_DATA.NS(REFERENCE_DATA.ACTIONS.FETCH_BANK_DATA)
      );

      if (this.applicationId) {
        // TODO: handle errors and so some kinda of loading indication
        await this.$store.dispatch(
          APPLICATION.NS(APPLICATION.ACTIONS.LOAD_APPLICATION),
          this.applicationId
        );

        this.loadPhysicalAddressDetails(this.physicalAddressDpid);
        this.loadDeliveryAddressDetails(this.deliveryAddressDpid);

        const applicationData = store.state.application.applicationData;
        const loyaltyDetails =
          applicationData && applicationData.loyaltyDetails;
        const promoOfferId = loyaltyDetails && loyaltyDetails.promoOfferId;
        const promoCode = loyaltyDetails && loyaltyDetails.promoCode;

        await this.$store.dispatch(
          REFERENCE_DATA.NS(REFERENCE_DATA.ACTIONS.FETCH_REFERENCE_DATA)
        );

        // reset the state first
        await this.$store.dispatch(
          PROMO_CODES.NS(PROMO_CODES.ACTIONS.RESET_STATE)
        );
        await this.$store.dispatch(
          STANDARD_OFFER.NS(STANDARD_OFFER.ACTIONS.RESET_STATE)
        );

        if (promoOfferId && promoCode) {
          await this.$store.dispatch(
            PROMO_CODES.NS(PROMO_CODES.ACTIONS.LOAD_PROMO_OFFER),
            promoOfferId
          );
        } else {
          const standardOfferId =
            loyaltyDetails && loyaltyDetails.standardOfferId;

          if (standardOfferId) {
            await this.$store.dispatch(
              STANDARD_OFFER.NS(STANDARD_OFFER.ACTIONS.LOAD_STANDARD_OFFER),
              standardOfferId
            );
          }
        }
      }
    },
    async loadPhysicalAddressDetails(value: any) {
      // load address deatils for IFCS screens
      await this.$store.dispatch(
        APPLICATION.NS(APPLICATION.ACTIONS.LOAD_PHYSICAL_ADDRESS_DETAILS),
        this.physicalAddressDpid
      );
    },
    async loadDeliveryAddressDetails(value: any) {
      // load address deatils for IFCS screens
      await this.$store.dispatch(
        APPLICATION.NS(APPLICATION.ACTIONS.LOAD_DELIVERY_ADDRESS_DETAILS),
        this.deliveryAddressDpid
      );
    }
  },
  computed: {
    listRouteName: () => ROUTE_NAMES.APPLICATIONS,
    isLoading(): boolean {
      const uiIsLoading = store.getters[UI.NS(UI.GETTERS.IS_LOADING)];
      const applicationIsLoading = store.state.application.isLoading;

      return uiIsLoading || applicationIsLoading;
    },
    applicationId(): any {
      return this.$route.params && this.$route.params.id;
    },
    showJdeDetails(): boolean {
      return isInSomeRole([TELNET, CREDIT, SUPPORT]);
    },
    showIfcsDetails(): boolean {
      return isInSomeRole([TELNET, CREDIT, SUPPORT]);
    },
    physicalAddressDpid: () =>
      store.state.application.applicationData &&
      store.state.application.applicationData.businessDetails &&
      store.state.application.applicationData.businessDetails.physicalAddress &&
      store.state.application.applicationData.businessDetails.physicalAddress
        .dpid,
    deliveryAddressDpid: () =>
      store.state.application.applicationData &&
      store.state.application.applicationData.finalDetails &&
      store.state.application.applicationData.finalDetails.deliveryAddress &&
      store.state.application.applicationData.finalDetails.deliveryAddress.dpid
  }
});
